import { HeaderDropdownData } from 'components/organisms/HeaderDropdown';

export const HeaderLinks = (allExpandData: HeaderDropdownData[]): HeaderDropdownData[] => [
	{ id: 1, name: '開始選購', expandData: allExpandData, to: '', externalLink: '' },
	{ id: 2, name: '最新消息', expandData: [], to: '/blog', externalLink: '' },
	{ id: 3, name: '關於愛康', expandData: [], to: '/about-us?tab=0', externalLink: '' },
	{ id: 4, name: '海外購物', expandData: [], to: '', externalLink: 'https://www.icon99.hk/' },
	{ id: 5, name: '性平之路', expandData: [], to: '/road-to-gender-equality', externalLink: '' },
];
